import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlusMultiple = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	className: "svg-icon",
	viewBox: "0 0 1024 1024",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M682.667 341.333h-85.334v128h-128v85.334h128v128h85.334v-128h128v-85.334h-128M85.333 512c0-119.04 69.974-221.867 170.667-269.653v-93.014C106.667 203.093 0 345.173 0 512s106.667 308.907 256 362.667v-93.014C155.307 733.867 85.333 631.04 85.333 512M640 128c-211.627 0-384 172.373-384 384s172.373 384 384 384 384-172.373 384-384-172.373-384-384-384m0 682.667c-164.693 0-298.667-133.974-298.667-298.667S475.307 213.333 640 213.333 938.667 347.307 938.667 512 804.693 810.667 640 810.667z" })
});
export default SvgPlusMultiple;
